module.exports = __webpack_public_path__ + "static/media/scanrectangle.a9915cf4.png";